import React from "react";
import { Link } from "react-router-dom";
import { Tag, ArrowRight } from "lucide-react";

export function DealsStrip({ offers = [], title = "Today's Deals" }) {
  if (!offers.length) return null;
  return (
    <section className="bg-primary/5 border-y border-primary/10" data-testid="deals-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex items-center gap-2 mb-5">
          <Tag className="w-5 h-5 text-primary" />
          <h2 className="font-display text-2xl font-bold">{title}</h2>
          <span className="rounded-full bg-primary text-white text-xs font-bold px-2 py-0.5">{offers.length}</span>
        </div>
        <div className="flex gap-4 overflow-x-auto no-scrollbar pb-2">
          {offers.map((o) => {
            const link = o.city_slug && o.category_slug && o.business_slug ? `/${o.city_slug}/${o.category_slug}/${o.business_slug}` : null;
            const inner = (
              <>
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-primary text-white text-xs font-bold px-2.5 py-1">{o.discount || "OFFER"}</span>
                  <Tag className="w-4 h-4 text-primary" />
                </div>
                <p className="font-display font-bold text-lg mt-3 leading-tight">{o.title}</p>
                {o.description && <p className="text-sm text-muted-foreground line-clamp-2 mt-1">{o.description}</p>}
                {o.business_name && <p className="text-xs font-semibold text-primary mt-3 flex items-center gap-1">{o.business_name} <ArrowRight className="w-3 h-3" /></p>}
              </>
            );
            const cls = "min-w-[260px] max-w-[260px] rounded-2xl border border-border bg-white p-4 shadow-sm hover:shadow-md transition-shadow";
            return link
              ? <Link key={o.id} to={link} className={cls} data-testid={`deal-${o.id}`}>{inner}</Link>
              : <div key={o.id} className={cls} data-testid={`deal-${o.id}`}>{inner}</div>;
          })}
        </div>
      </div>
    </section>
  );
}
